import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div>
            <h3
              className="text-lg font-bold text-foreground-950 mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              51吃瓜网
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              聚焦51吃瓜网今日大瓜、51吃瓜今日吃瓜必吃等核心吃瓜专题。按热度整理每日大赛、最新爆料与热门黑料，帮你快速定位今日最值得吃的瓜。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/jinri-dagua"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  今日大瓜
                </Link>
              </li>
              <li>
                <Link
                  to="/category/meiri-dasai"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  每日大赛
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              联系我们
            </h4>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-600">
                <span className="inline-flex items-center gap-2">
                  <i className="ri-mail-line text-primary-500" />
                  hello@yuefenggroup.cn
                </span>
              </li>
              <li className="text-sm text-foreground-600">
                <span className="inline-flex items-center gap-2">
                  <i className="ri-time-line text-primary-500" />
                  每日更新 · 全天无休
                </span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="站内动态"
              >
                <i className="ri-chat-1-line" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="短讯"
              >
                <i className="ri-notification-3-line" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 51吃瓜网. 本站所有内容仅供娱乐参考，不代表任何立场。
          </p>
          <div className="flex gap-4">
            <Link
              to="/about"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
            >
              隐私政策
            </Link>
            <Link
              to="/about"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors"
            >
              免责声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
